<template>
  <div class="Callout" :class="`Callout--${size}`">
    <slot>{{ text }}</slot>
  </div>
</template>

<script setup lang="ts">
import type { CalloutProps } from './Callout.model';

withDefaults(defineProps<CalloutProps>(), { size: 'md' });
</script>

<style lang="scss">
@use '@cvo/ui/styles/design-system' as vars;
@use '@cvo/ui/styles/utils/responsive';
@use '@cvo/ui/styles/utils/text';

@layer cvo-ui {
  .Callout {
    display: flex;
    align-items: center;
    padding: vars.$dimensions-d-3 vars.$dimensions-d-4;
    color: vars.$atoms-callout-text-color;
    background-color: var(--section-surface-color, #{vars.$atoms-callout-bg-color});
    border-inline-start: vars.$dimensions-d-1 solid vars.$atoms-callout-border-color;
    border-radius: vars.$dimensions-d-2;

    @include responsive.tablet {
      min-block-size: 72px;
      padding: vars.$dimensions-d-3 vars.$dimensions-d-6;
      border-radius: vars.$dimensions-d-3-5;
    }

    // Kept last: emits @media blocks, so declarations must precede it
    @include text.text-responsive('xs', 'md');

    &--sm {
      min-block-size: auto;
      padding: vars.$dimensions-d-3 vars.$dimensions-d-4;
      border-radius: vars.$dimensions-d-2;
      @include text.text(xs);
    }
  }
}
</style>
